export default "<ion-row class=\"overflow-auto\">\n\t<ion-col size=\"12\">\n\t\t<div [innerHTML]=\"desc\"></div>\n\t</ion-col>\n</ion-row>\n";